<template>
  <div class="main-container p-3">
    <KidHeader :profileId="profileId" :serialNumber="serialNumber" />
      <div class="profile-section mb-2">
          <div class="pl-2">
              <span>
                  <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})"><i class="fas fa-long-arrow-alt-left"></i> <b>Home</b></a>
              </span>
          </div>
      </div>

    <!-- Device Options -->
    <div class="card shadow-sm mb-4">
        <div class="card-body text-center">
            <h5 class="card-title text-black">
            <i class="fas fa-cogs text-primary me-2"></i> Device Options
            </h5>
            <p class="text-muted mb-3">
            Secure or restart the child’s device remotely. You can lock the device for safety or reboot it to resolve any issues.
            </p>
            
            <!-- Action Buttons -->
            <div class="d-flex justify-content-center gap-3 flex-wrap">

              <!-- Lock Device -->
              <button
                class="btn btn-warning px-4 d-flex align-items-center"
                :disabled="isDisabled"
                @click="sendDeviceCommand('LOCK')"
              >
                <i class="fas fa-lock me-2 pr-1"></i>
                Lock
                <i
                  v-if="isDisabled && currentAction === 'LOCK'"
                  class="fa fa-spinner fa-spin ms-2"
                ></i>
              </button> &nbsp;

              <!-- Reboot Device -->
              <button
                class="btn btn-outline-secondary px-4 d-flex align-items-center"
                :disabled="isDisabled"
                @click="sendDeviceCommand('REBOOT')"
              >
                <i class="fas fa-sync-alt me-2 pr-1"></i>
                Reboot
                <i
                  v-if="isDisabled && currentAction === 'REBOOT'"
                  class="fa fa-spinner fa-spin ms-2"
                ></i>
              </button>

            </div>
        </div>
    </div>

    <!-- Device Details -->
    <div class="card shadow-sm mb-4 device-details-card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="card-title text-black mb-0">
            <i class="fas fa-info-circle text-primary me-2"></i> Device Details
          </h5>
          <button class="btn btn-sm btn-primary" :disabled="isDisabled" @click="syncDeviceDetails()">
            <i class="fas fa-sync-alt me-1"></i> Sync <span v-if="isDisabled" class="ms-2">
                    <i class="fa fa-spinner fa-spin"></i>
                </span>
          </button>
        </div><hr>
        <p class="text-muted mb-3">
            View detailed technical information about the child’s device, including system version, hardware, network status, and memory capacity.
        </p>

        <div class="detail-grid">
          <div class="detail-item">
            <i class="fas fa-battery-half icon"></i>
            <span><strong>Battery Level:</strong> {{ deviceDetails.batteryLevel }}%</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-clock icon"></i>
            <span><strong>Checked At:</strong> {{ deviceDetails.batteryCheckedAt }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-barcode icon"></i>
            <span><strong>Serial Number:</strong> {{ deviceDetails.serialNumber }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-mobile-alt icon"></i>
            <span><strong>Model:</strong> {{ deviceDetails.model }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-industry icon"></i>
            <span><strong>Brand:</strong> {{ deviceDetails.brand }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-microchip icon"></i>
            <span><strong>Hardware:</strong> {{ deviceDetails.hardware }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-signal icon"></i>
            <span><strong>Baseband:</strong> {{ deviceDetails.basebandVersion }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-cogs icon"></i>
            <span><strong>Manufacturer:</strong> {{ deviceDetails.manufacturer }}</span>
          </div>
          <div class="detail-item">
            <i class="fab fa-android icon"></i>
            <span><strong>Android Version:</strong> {{ deviceDetails.androidVersion }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-globe icon"></i>
            <span><strong>Language:</strong> {{ deviceDetails.languageCode }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-fingerprint icon"></i>
            <span><strong>IMEI:</strong> {{ deviceDetails.imei }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-wifi icon"></i>
            <span><strong>WiFi MAC:</strong> {{ deviceDetails.wifiMac }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-network-wired icon"></i>
            <span><strong>Network:</strong> {{ deviceDetails.networkOperator }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-phone icon"></i>
            <span><strong>Phone:</strong> {{ deviceDetails.phoneNumber }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-memory icon"></i>
            <span><strong>RAM:</strong> {{ deviceDetails.totalRam }}</span>
          </div>
          <div class="detail-item">
            <i class="fas fa-hdd icon"></i>
            <span><strong>Storage:</strong> {{ deviceDetails.totalStorage }}</span>
          </div>
        </div>
      </div>
    </div>

    <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
  </div>
</template>

<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from "../../services/KidsService";
import ProfileService from "../../services/ProfileService";

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter,
  },
  data() {
    return {
        profileId: this.$route.query.profileId,
        serialNumber: this.$route.query.serialNumber,
        isDisabled: false,
        deviceDetails: {}
    }
  },
  methods: {
    async getDeviceInfo() {
        const data = {
            serialNumber: this.$route.query.serialNumber
        };

        await KidsService.getDeviceInfo(data)
        .then((response) => {
          this.deviceDetails = response.data.data
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    }, 
    async syncDeviceDetails() {
        this.isDisabled = true;
        const data = {
            id: this.deviceDetails.id
        };

        await KidsService.syncDeviceDetails(data)
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
          this.isDisabled = false;
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    }, 
    async sendDeviceCommand(action) {
        this.isDisabled = true;
        this.currentAction = action;
        const data = {
            type: action,
            serialNumber: this.serialNumber
        };

        try {
            await KidsService.sendDeviceCommand(data);
            this.$toast.success(`${action} command sent.`);
        } catch (err) {
            this.$toast.error(err.response?.data?.respones_msg || 'Failed to send command.');
        } finally {
            this.isDisabled = false;
        }
    } 
  },
  beforeMount() {
    this.getDeviceInfo();
  },
}
</script>
<style scoped>
.card {
  border-radius: 10px;
}
input[type="text"] {
  font-size: 1.1rem;
}
.btn-icon-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon-flex i {
  margin-right: 8px;
}

.device-details-card {
  border-radius: 12px;
  background-color: #fff;
  padding: 1.2rem;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 12px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.95rem;
  color: #333;
  line-height: 1.4;
}

.detail-item .icon {
  color: #4a90e2;
  min-width: 18px;
  font-size: 1rem;
  margin-top: 2px;
}

</style>